import React from 'react';
import { useTranslation } from 'react-i18next';

const AIInsightCard = ({ insightText }) => {
  const { t } = useTranslation();
  // Si no hay texto de insight, no renderizamos nada para mantener la UI limpia
  if (!insightText) return null;

  return (
    <div style={{
      backgroundColor: '#4a5568', // Un tono más claro que el fondo #2d3748 (bg-slate-700 aprox)
      borderRadius: '12px',       // rounded-xl
      padding: '20px',
      marginTop: '24px',          // mt-6
      border: '1px solid rgba(255, 255, 255, 0.1)', // Borde sutil
      boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)', // Shadow-lg
      display: 'flex',
      flexDirection: 'column',
      gap: '8px'
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}>
        <span role="img" aria-label="sparkles" style={{ fontSize: '1.2em' }}>✨</span>
        <h4 style={{
          margin: 0,
          color: '#F6E05E', // Dorado/Amarillo (text-yellow-300 aprox)
          fontSize: '0.9em',
          fontWeight: 'bold',
          textTransform: 'uppercase',
          letterSpacing: '0.05em'
        }}>
          {t('analytics.ai_analysis')}
        </h4>
      </div>
      <p style={{
        margin: 0,
        color: '#E2E8F0', // Gris claro (text-gray-300)
        fontSize: '0.95em',
        lineHeight: '1.6'
      }}>
        {insightText}
      </p>
    </div>
  );
};

export default AIInsightCard;